var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 85,
    viewBox: "0 0 98 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.0855 15.4868C81.0855 15.4868 66.1977 18.911 67.0165 32.4671C67.1405 36.8824 68.9535 41.07 72.0633 44.1241L78.6796 50.7099",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6523 33.9248L92.123 41.5634",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0171 56.2065C67.0171 56.2065 69.2245 67.5087 80.0592 68.4307",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5322 15.9409C18.4576 16.0345 19.3698 16.2353 20.2511 16.5396C26.5757 18.6591 31.5453 24.7281 31.5453 31.5534L31.2281 49.3979",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0097 33.6982L5.48633 42.3537L13.5611 50.5283",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4272 68.041H28.7214",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4545 33.8675C18.0527 33.8675 19.3484 32.5379 19.3484 30.8978C19.3484 29.2578 18.0527 27.9282 16.4545 27.9282C14.8562 27.9282 13.5605 29.2578 13.5605 30.8978C13.5605 32.5379 14.8562 33.8675 16.4545 33.8675Z",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.557 55.9866C17.1553 55.9866 18.4509 54.6571 18.4509 53.017C18.4509 51.3769 17.1553 50.0474 15.557 50.0474C13.9587 50.0474 12.6631 51.3769 12.6631 53.017C12.6631 54.6571 13.9587 55.9866 15.557 55.9866Z",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2391 55.7571C32.8374 55.7571 34.133 54.4276 34.133 52.7875C34.133 51.1474 32.8374 49.8179 31.2391 49.8179C29.6409 49.8179 28.3452 51.1474 28.3452 52.7875C28.3452 54.4276 29.6409 55.7571 31.2391 55.7571Z",
    stroke: "white",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6156 71.2088C33.2139 71.2088 34.5095 69.8792 34.5095 68.2392C34.5095 66.5991 33.2139 65.2695 31.6156 65.2695C30.0173 65.2695 28.7217 66.5991 28.7217 68.2392C28.7217 69.8792 30.0173 71.2088 31.6156 71.2088Z",
    stroke: "white",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.66 55.7571C68.2583 55.7571 69.5539 54.4276 69.5539 52.7875C69.5539 51.1474 68.2583 49.8179 66.66 49.8179C65.0618 49.8179 63.7661 51.1474 63.7661 52.7875C63.7661 54.4276 65.0618 55.7571 66.66 55.7571Z",
    stroke: "white",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.306 55.7571C82.9043 55.7571 84.1999 54.4276 84.1999 52.7875C84.1999 51.1474 82.9043 49.8179 81.306 49.8179C79.7078 49.8179 78.4121 51.1474 78.4121 52.7875C78.4121 54.4276 79.7078 55.7571 81.306 55.7571Z",
    stroke: "white",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9998 52.8466C96.9998 61.1715 90.3492 67.9217 82.1402 67.9217C81.8448 67.9217 81.5609 67.9217 81.2712 67.9217C81.2712 68.1564 81.2712 68.391 81.2712 68.6319C81.2712 76.9569 74.6206 83.707 66.4116 83.707C63.8573 83.7321 61.3394 83.061 59.0967 81.7576C56.854 80.4541 54.9609 78.5614 53.597 76.259C52.4161 74.1731 51.8023 71.7783 51.8243 69.3421V15.341C51.7975 13.1387 52.3001 10.9659 53.2841 9.0293C54.6044 6.5671 56.517 4.52501 58.8247 3.11371C61.1323 1.70241 63.7513 0.973007 66.4116 1.00076C74.6206 1.00076 81.2712 7.75708 81.2712 16.0882H81.81C90.0132 16.0882 96.6696 22.8322 96.6696 31.1634C96.667 33.168 96.279 35.1508 95.5298 36.9894C94.7805 38.828 93.6858 40.4835 92.3131 41.8537C93.7811 43.2267 94.9583 44.917 95.7663 46.8124C96.5744 48.7077 96.9949 50.7647 96.9998 52.8466Z",
    stroke: "white",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 52.8724C1.00487 54.8609 1.39833 56.8289 2.1578 58.6633C2.91727 60.4977 4.02779 62.1624 5.42557 63.5617C6.82334 64.9611 8.48085 66.0676 10.3029 66.8176C12.125 67.5677 14.0757 67.9465 16.043 67.9325C16.3417 67.9325 16.6342 67.9325 16.9268 67.9325C16.9268 68.1652 16.9268 68.4043 16.9268 68.6433C16.9557 71.9622 18.0588 75.1803 20.0674 77.806C22.0761 80.4317 24.8799 82.3206 28.0505 83.1842C31.2212 84.0478 34.5844 83.8386 37.6263 82.5885C40.6682 81.3384 43.2217 79.1162 44.8966 76.2614C46.0977 74.1592 46.7168 71.769 46.6891 69.3416V15.4111C46.712 13.224 46.2056 11.0644 45.214 9.12036C43.6505 6.11747 41.1377 3.7298 38.076 2.33775C35.0142 0.945694 31.5797 0.629327 28.3194 1.43905C25.0591 2.24877 22.1607 4.13799 20.0859 6.80576C18.0111 9.47353 16.8793 12.7664 16.8707 16.1597H16.323C14.3552 16.1498 12.4048 16.5329 10.5839 17.2872C8.76301 18.0415 7.10752 19.152 5.71256 20.555C4.31759 21.9579 3.21065 23.6256 2.45532 25.4623C1.69999 27.299 1.31117 29.2684 1.31119 31.2575C1.30627 33.2476 1.69461 35.2187 2.45342 37.0551C3.21224 38.8915 4.32625 40.5563 5.7301 41.9517C4.24258 43.3466 3.05499 45.036 2.24124 46.9148C1.42748 48.7936 1.00497 50.8215 1 52.8724Z",
    stroke: "white",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4134 34.3323C83.0117 34.3323 84.3073 33.0028 84.3073 31.3627C84.3073 29.7226 83.0117 28.3931 81.4134 28.3931C79.8152 28.3931 78.5195 29.7226 78.5195 31.3627C78.5195 33.0028 79.8152 34.3323 81.4134 34.3323Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3da12877619bf5e9f2dbf5e97d10c9ed.svg";
export { ForwardRef as ReactComponent };